// extracted by mini-css-extract-plugin
export var btn = "style-module--btn--d0758";
export var info = "style-module--info--64f64";
export var mainList = "style-module--main-list--fcc4b";
export var prof = "style-module--prof--903e4";
export var reg = "style-module--reg--d771a";
export var speakers = "style-module--speakers--63b90";
export var wrap = "style-module--wrap--aeeed";